export default "__VITE_ASSET__6d3ffb8f__"